import { z } from 'zod';

// Catálogo único de códigos de error de la API pública (RF-07.02). Cada código tiene un
// estado HTTP fijo: la v1 respondía `200` con `code: 402` en el cuerpo y eso no se repite.
export const errorStatus = {
  bad_request: 400,
  validation_error: 400,
  invalid_cursor: 400,
  idempotency_key_required: 400,
  idempotency_key_invalid: 400,
  unauthenticated: 401,
  insufficient_credits: 402,
  forbidden: 403,
  csrf_failed: 403,
  not_found: 404,
  method_not_allowed: 405,
  conflict: 409,
  idempotency_in_progress: 409,
  expired: 410,
  payload_too_large: 413,
  unsupported_media_type: 415,
  idempotency_key_reused: 422,
  rate_limited: 429,
  internal_error: 500,
  service_unavailable: 503,
} as const satisfies Record<string, number>;

export type ErrorCode = keyof typeof errorStatus;

export const errorCodes = Object.keys(errorStatus) as [ErrorCode, ...ErrorCode[]];

export const errorCodeSchema = z.enum(errorCodes);

export const errorDetailSchema = z.object({
  /** Ruta del campo con el problema, en formato JSON Pointer (`/input/prompt`). */
  path: z.string(),
  message: z.string(),
});

/** Cuerpo de toda respuesta de error: `{ error: { code, message, requestId, details? } }`. */
export const apiErrorSchema = z
  .object({
    error: z.object({
      code: errorCodeSchema,
      /** Texto en castellano para la persona; dice si se ha cobrado algo. */
      message: z.string(),
      /** Mismo valor que la cabecera `X-Request-Id`. */
      requestId: z.string(),
      details: z.array(errorDetailSchema).optional(),
    }),
  })
  .meta({ id: 'ApiError' });

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
export type ErrorDetail = z.infer<typeof errorDetailSchema>;
